import {LocaleDateTimeFormat} from '../../../types/LocaleDateTimeFormat';

type PosibleDayMonthFormat = 'dateShort' | 'dateMedium';

export type LocaleDayMonthFormat = LocaleDateTimeFormat & PosibleDayMonthFormat;
